/* globals google, $ */
import SearchClass from './SearchClass.js';
import SearchResultsList from './SearchResultsList.js';
import alphanum from './alphanum.js';
import language from './language.js';

export default class Search {
  constructor(field) {
    this.field = field;
    this.provider = this.baseSearch;
    this.customSearch = new SearchClass(language);
    this.googleService = new google.maps.places.AutocompleteService();
    this.result = [];
    this.resultList = new SearchResultsList(field);
    this.inputStarted = false;
    this.init();
  }

  init() {
    $(document.getElementsByName(this.field)).change(e => {
      if (!this.inputStarted) {
        this.baseSearch(e.target.value);
      }
    });

    $(document.getElementsByName(this.field)).keyup(e => {
      this.inputStarted = true;
      if (alphanum(e)) {
        this.baseSearch(e.target.value);
      }
    });
  }

  baseSearch = val => {
    this.result = this.customSearch.make(val);
    if (!this.result.length) {
      this.googleSearch(val);
    } else {
      this.resultList.show(this.result);
    }
  };

  googleSearch = val => {
    if (val && val.length > 3) {
      this.googleService.getPlacePredictions(
        { input: val, componentRestrictions: { country: 'it' } },
        (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            console.log(status); // eslint-disable-line no-console
            if (status === 'ZERO_RESULTS') {
              this.resultList.geocoder.geocode(
                { address: predictions[0].place_id },
                (results, geocodeStatus) => {
                  if (geocodeStatus === google.maps.GeocoderStatus.OK) {
                    // console.log('results', results);
                    const place = results[0];
                    const placeData = {};
                    placeData.formatted_address = place.formatted_address;
                    placeData.name = place.name;
                    placeData.city = place.address_components.filter(el =>
                      (
                        el.types[0] === 'locality' ||
                        el.types[0] === 'administrative_area_level_3'
                      )
                    );
                    // console.log('place',place);
                    // $(`input[name="${self.field}"]`).val(place.formatted_address);
                    $(`input[name="${this.field}Id"]`).val('');
                    document.getElementsByName(
                      `${this.field}Data`
                    )[0].value = JSON.stringify(placeData);
                  } else {
                    console.log("Can't find address: ", geocodeStatus); // eslint-disable-line no-console
                  }
                }
              );
            }
            return;
          }
          this.resultList.showGoogle(predictions);
        }
      );
    }
    // console.log('googleSearch',val);
  };
}



// WEBPACK FOOTER //
// ./public/scripts/webpack/search.js